enum SchedulingActivityType {
  Unknown = 'Unknown',
  DirectDelivery = 'DirectDelivery', //3rd Party delivery
  LocalDelivery = 'LocalDelivery', //Delivery by Carvana
  LocalDeliveryWithTrade = 'LocalDeliveryWithTrade',
  LocalDeliveryWithSwap = 'LocalDeliveryWithSwap',
  Pickup = 'Pickup',
  PickupWithTrade = 'PickupWithTrade',
  PickupWithSwap = 'PickupWithSwap',
  ReturnPickup = 'ReturnPickup',
  ReturnDropoff = 'ReturnDropoff',
  TradePickup = 'TradePickup',
  TradeDropoff = 'TradeDropoff',
  RepairPickup = 'RepairPickup',
  RepairDropoff = 'RepairDropoff',
  MarketplacePickup = 'MarketplacePickup'
}

export default SchedulingActivityType;
